// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-widget__native-payment__container{\n    padding: 0 16px;\n}", "",{"version":3,"sources":["webpack://./node_modules/@bhn/oc-payments-js/dist/style/native-payment/main.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB","sourcesContent":[".payment-widget__native-payment__container{\n    padding: 0 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
